import { countyModelData } from './models/CountiesModel'
import { AdminCountyService } from './api/AdminCountyService'

const CountyModule = {
  namespaced: true,
  state: countyModelData(),
  getters: {
    fetchCountyList: state => state.countyList,
    fetchSearchCountyList: state => state.searchCountyList,
    fetchCountyFipsList: state => state.countyFipsList
  },
  mutations: {
    setCountyList (state, data) {
      state.countyList = data.list
    },
    setSearchCountyList (state, data) {
      state.searchCountyList = data.list
    },
    setCountyFips (state, data) {
      state.countyFipsList = data.list
    }
  },
  actions: {
    /**
     * Get counties list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param credentials | object
     */
    async getCountyList ({ commit }, { resolve, reject, countryId, stateId, fetchOnlyPublished }) {
      try {
        const response = await AdminCountyService.fetchCountyList(countryId, stateId, fetchOnlyPublished)
        const { success, data } = response.data
        if (success === true) {
          commit('setCountyList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setCountyList', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async addCountyItem ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminCountyService.addCountyItem(formData)
        const { success, data } = response.data
        if (success) {
          dispatch('getCountyList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async editCountyItem ({ dispatch }, { resolve, reject, editedData }) {
      try {
        const response = await AdminCountyService.editCountyItem(editedData)
        const { success, data } = response.data
        if (success) {
          dispatch('getCountyList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getCountyDetailsById ({ commit }, { resolve, reject, idToGetInfo }) {
      try {
        const response = await AdminCountyService.getCountyDetailsById(idToGetInfo)
        const { success, data } = response.data
        if (success === true) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async validateCountyItem ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminCountyService.validateCountyItem(formData)
        const { success, data } = response.data
        if (success === true) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async deleteCountyItem ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminCountyService.deleteCountyItem(formData)
        const { success, data } = response.data
        if (success === true) {
          dispatch('getCountyList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async searchCountyItem ({ commit }, { resolve, reject, searchData }) {
      try {
        const response = await AdminCountyService.searchCountyItem(searchData)
        const { success, data } = response.data
        if (success === true) {
          commit('setSearchCountyList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setSearchCountyList', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getCountyFips ({ commit }, { resolve, reject }) {
      try {
        const response = await AdminCountyService.fetchCountyFips()
        const { success, data } = response.data
        if (success === true) {
          commit('setCountyFips', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setCountyFips', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    }
  }
}
export default CountyModule
